import { GET } from './api';

export const GetAppData = async () => {
  return await GET('/get-app-data', true);
};

export const GetCount = async () => {
  return await GET('/get-count', true);
};
